/**
 * @Description 关联机会点后的显示
 */

import { FC, useState } from 'react';
// import cs from 'classnames';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Col, Popover, Row } from 'antd';
import IconFont from '@/common/components/IconFont';

const CorrelatedChancePoint: FC<{
  chancepointAlias,
  relativeChancePoints,
  createChancePoint,
  relativeChancePoint,
  setPointId,
  setDetailVisible,
  /** 是否展示机会点操作 */
  ableToChangepoint: boolean,
}> = ({
  chancepointAlias,
  relativeChancePoints,
  createChancePoint,
  relativeChancePoint,
  setPointId,
  setDetailVisible,
  ableToChangepoint = true, // 是否展示机会点操作
}) => {
  const [isExpanded, setExpanded] = useState(false); // 是否设置展开

  return (
    <div className={styles.correlatedChancePoint}>
      <V2Title type='H2' text='记录点位信息' extra={
        ableToChangepoint ? <Popover overlayClassName={styles.popoverWrap} placement='bottomRight' title={null} content={(
          <div className={styles.continueAddPointType}>
            <div className={styles.typeItem} onClick={createChancePoint}>新建{chancepointAlias}</div>
            <div className={styles.typeItem} onClick={relativeChancePoint}>关联{chancepointAlias}</div>
          </div>
        )} trigger='hover'>
          <div className={styles.continueAddPoint}>
            <PlusCircleOutlined />
            <span>继续添加</span>
          </div>
        </Popover> : <></>}
      />
      <Row gutter={16} style={{ paddingRight: '144px', boxSizing: 'border-box' }}>
        { relativeChancePoints.map((item: any, index: number) => (
          <Col span={12} key={index} style={{ display: (!isExpanded && index >= 2) ? 'none' : 'block' }}>
            <div className={styles.chancePointItem} onClick={() => {
              setPointId(item.id);
              setDetailVisible(true);
            }}><div className={styles.chancePointItemName}>{item.name}</div><div className={styles.chancePointItemStatus}>{item.statusName}</div><div className={styles.chancePointItemIcon}><IconFont iconHref='iconic_zhuanjiao_seven' /></div></div>
          </Col>
        )) }
        { relativeChancePoints?.length > 2 && <Col span={24} className='mt-8'><span className={styles.moreBtn} onClick={() => setExpanded(!isExpanded)}>{ isExpanded ? '收起' : '展开' }更多</span></Col> }
      </Row>
    </div>
  );
};

export default CorrelatedChancePoint;
